import { usePageStore } from '~dsc/stores/cms/page';
import { defineNuxtRouteMiddleware } from '#imports';

export default defineNuxtRouteMiddleware(async to => {
    if (import.meta.server) {
        await usePageStore().pageLoad(to);
    }
});
